import { useI18n } from "../i18n/index.js";
import { CenteredPage, LinkButton } from "../ui/index.js";

export function NotFoundRoute() {
  const { t } = useI18n();
  return (
    <CenteredPage>
      <div className="dt-centered__head" style={{ textAlign: "center" }}>
        <h1>{t("notFound.title")}</h1>
        <p className="dt-muted">{t("notFound.hint")}</p>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <LinkButton to="/" variant="primary">
          {t("notFound.action")}
        </LinkButton>
      </div>
    </CenteredPage>
  );
}
